import React from 'react';
import { Routes, Route } from 'react-router-dom';
import NotFound from 'router/components/NotFound';
import subRoutes from './subRoutes';
import { SupplierCatalog } from './SupplierCatalog';
import { CatalogProductDetail } from './CatalogProductDetail';

const SupplierCatalogRoute = () => {
  return (
    <Routes>
      <Route path={subRoutes.catalog} element={<SupplierCatalog />} />
      <Route path={subRoutes.productDetail} element={<CatalogProductDetail />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default SupplierCatalogRoute;
